<template>
  <div>
    <page-header title="Shipment Timeline" breadcrumb="Dashboard > Bookings & Shipments  > Trackings" :back="{ name: 'Tracking' }" />
    <div class="custom-card">
        <div class="flex justify-between items-center">
            <p class="text-2xl font-bold">
                Shipping ID: #{{ shipment.shippingReference }}
                <span class="text-lightGrey ml-4 text-sm">{{ nowDate }}</span>
            </p>
            <base-button @click="showupdateModal = true" text="Update Status" />
        </div>
        <div class="p-4 mt-4 flex gap-4 text-white" style="background: #09B78A;">
            <span class="icon-bg">
                <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M8.94192 1.40008L1.80192 8.49058C1.52142 8.76816 1.29874 9.09861 1.14676 9.4628C0.994791 9.82699 0.916541 10.2177 0.916541 10.6123C0.916541 11.007 0.994791 11.3977 1.14676 11.7619C1.29874 12.1261 1.52142 12.4565 1.80192 12.7341L6.76692 17.6661C7.94742 18.8361 9.85842 18.8361 11.0374 17.6661L18.0724 10.6791C18.6322 10.1227 18.9501 9.36824 18.9574 8.57908L18.9934 3.52108C18.9948 3.12296 18.9172 2.72851 18.7652 2.36056C18.6131 1.99262 18.3895 1.6585 18.1075 1.37754C17.8254 1.09658 17.4904 0.874357 17.1218 0.723741C16.7533 0.573125 16.3585 0.497106 15.9604 0.500084L11.0644 0.521084C10.2692 0.523719 9.50686 0.838886 8.94192 1.39858V1.40008ZM15.0289 5.98708C14.8115 6.20271 14.5177 6.3237 14.2114 6.3237C13.9052 6.3237 13.6114 6.20271 13.3939 5.98708C13.2868 5.88083 13.2018 5.75442 13.1438 5.61514C13.0857 5.47586 13.0559 5.32647 13.0559 5.17558C13.0559 5.0247 13.0857 4.87531 13.1438 4.73603C13.2018 4.59675 13.2868 4.47034 13.3939 4.36408C13.6114 4.14846 13.9052 4.02747 14.2114 4.02747C14.5177 4.02747 14.8115 4.14846 15.0289 4.36408C15.4789 4.81408 15.4789 5.54008 15.0289 5.98708ZM0.996422 13.6251C0.794917 14.1644 0.752827 14.7502 0.875175 15.3127C0.997522 15.8753 1.27914 16.3907 1.68642 16.7976L4.63242 19.7436C5.18958 20.3008 5.85103 20.7428 6.579 21.0443C7.30697 21.3458 8.08721 21.5011 8.87517 21.5011C9.66313 21.5011 10.4434 21.3458 11.1713 21.0443C11.8993 20.7428 12.5608 20.3008 13.1179 19.7436L18.3409 14.5206C18.763 14.099 19.0004 13.5271 19.0009 12.9306V11.7606L13.1179 17.6436C13.0144 17.7471 12.9079 17.8461 12.7999 17.9391L12.0574 18.6831C11.6395 19.101 11.1434 19.4326 10.5974 19.6588C10.0514 19.885 9.46618 20.0014 8.87517 20.0014C8.28416 20.0014 7.69894 19.885 7.15292 19.6588C6.60691 19.4326 6.1108 19.101 5.69292 18.6831L4.94442 17.9346C4.83707 17.8412 4.73301 17.7442 4.63242 17.6436L1.68642 14.6976C1.38196 14.3939 1.1466 14.0281 0.996422 13.6251Z"
                        fill="#09B78A" />
                </svg>

            </span>
            <div class="flex flex-col">
                <p class="font-semibold">Standard Shipping</p>
                <span>This order has been shipped to the customer</span>
            </div>
        </div>
        <div class="px-4 mt-3">
            <div class="timeline relative">
                <div class="timeline-bar">
                    <div class="dotted"></div>
                </div>
                <div class="points">
                    <el-tooltip class="item" effect="dark" content="Item has been dipsatched" placement="top">
                        <div class="mb-3"></div>
                    </el-tooltip>
                    <p>Created</p>
                    
                </div>
                <div v-for="(timelines, index) in shipment.timelines" :key="timelines.id" class="points">
                    <el-tooltip class="item" effect="dark" :content="timelines.message" placement="top">
                        <div :class="{ 'last-child' : shipment.timelines.length == index + 1 }" class=""></div>
                    </el-tooltip>
                    <p>{{ capitalize(timelines.activityType) }} </p>
                    <span>{{ timelines.createdAt | formatDate }}, {{ timelines.createdAt | formatTime }}</span>
                   
                </div>

                 <div class="points">
                    <el-tooltip class="item" effect="dark" content="Item has been dipsatched" placement="top">
                        <div class="mb-3"></div>
                    </el-tooltip>
                    <p>ETA</p>
                   
                </div>
            </div>
        </div>
        
        <div class="flex flex-col gap-2 py-4 px-4 mt-5" style="background: #F9FAFC;">
            <div class="flex flex-wrap justify-between">
              <p class=" font-normal">Shipping Information</p>
              
              <div @click="showShippingInfo = !showShippingInfo" class="flex flex-wrap gap-2 cursor-pointer">
                <IconArrowUp class="mt-2" v-if="showShippingInfo" />
                <IconArrowDown class="mt-2" v-if="!showShippingInfo" />
                <p>{{ showShippingInfo ? "Collapse" : "Expand" }}</p>
              </div>
              
            </div>
            
            <div v-if="showShippingInfo" class="row p-3 flex flex-wrap justify-between">
                <div class="col-md-3 flex flex-col gap-4">
                    <p class="font-semibold">SENDER INFORMATION</p>
                    <p class="flex flex-col">
                        {{ shipment.shipperlocation ? shipment.shipperlocation.contactName : "N/A" }}
                        <span class="text-red-500">{{ shipment.shipperlocation ? shipment.shipperlocation.mobile : "" }}</span>
                    </p>
                    <p></p>
                    <p>
                      {{ shipment.shipperlocation ? shipment.shipperlocation.address.name : "N/A" }}
                    </p>
                </div>
                <div class="col-md-3 flex flex-col gap-4">
                    <p class="font-semibold">RECEIVER INFORMATION</p>
                    <p class="flex flex-col ">
                        {{ shipment.consigneelocation ? shipment.consigneelocation.contactName : "N/A" }}
                        <span class="text-red-500">{{ shipment.consigneelocation ? shipment.consigneelocation.mobile : "" }}</span>
                    </p>
                    <p></p>
                    <p>
                       {{ shipment.consigneelocation ? shipment.consigneelocation.address.name : "N/A" }}
                    </p>
                </div>
                <div class="col-md-3 flex flex-col gap-4">
                    <p class="font-semibold">ORDER CHANNEL</p>
                    <p class="flex flex-col">
                        {{ 'Muleex' }}
                    </p>
                    <p class="font-semibold">ORDER #</p>
                    <p>
                        {{ shipment.shippingReference }}
                    </p>
                    <p class="font-semibold">INSURED VALUE</p>
                    <p>
                        {{ shipment.transaction ? 'N' + shipment.transaction.amount_paid : "N/A"  }}
                    </p>
                </div>
                <div class="col-md-3 flex flex-col gap-4">
                    <p class="font-semibold">SHIPPING COST</p>
                    <p class="flex flex-col ">
                      {{ shipment.transaction ? 'N' + shipment.transaction.amount_paid : "N/A"  }}
                        
                    </p>
                    <p class="font-semibold">PAYMENT STATUS</p>
                    <p>
                      {{ shipment.transaction ? shipment.transaction.status : "N/A"  }}
                    </p>
                    <p class="font-semibold">CARD</p>
                    <p>
                      {{ shipment.transaction ? '*********' + shipment.transaction.lastfour : "*********"  }}
                    </p>
                </div>
            </div>
        </div>

        <p class="font-semibold text-lg mt-5">Order Items</p>
        <table class="custom-table responsive-table border-collapse">
          <thead>
            <tr class="shadow-md rounded-lg">
              <th>Item</th>
              <th>Quantity</th>
              <th>Dimension (Cm)</th>
              <th>Gross Weight(kg)</th>
              <th>Total Cost(N)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="pack in shipment.packagees" :key="pack.id" class="shadow-md rounded-lg">
              <td>{{ pack.description }}</td>
              <td>{{ pack.quantity }}</td>
              <td>{{ pack.length ? pack.length : "N/A" }}</td>
              <td>{{ pack.estimatedWeight }}</td>
              <td>{{ pack.itemValue }}</td>
            </tr>
          </tbody>
        </table>
       
        <UpdateStatusModal :showmodal="showupdateModal" @refetchBooking="getShippingTimeline" :booking="shipment" @close-modal="showupdateModal = false"/>
    </div>
</div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import UpdateStatusModal from "@/components/3pl/Settings/Tracking/Modals/UpdateStatusModal.vue";
import IconArrowUp from "@/components/UI/svgs/IconArrowUp.vue"
import IconArrowDown from "@/components/UI/svgs/IconArrowDown.vue"
import moment from "moment";

export default {
  components: {
    PageHeader,
    UpdateStatusModal, 
    IconArrowUp,
    IconArrowDown
  },
  data(){
    return {
      loading: false,
      shipment : [],
      showupdateModal : false,
      showShippingInfo : true,
      nowDate : ""
    }
  },
  computed: {
    
  },
  methods: {
    async getShippingTimeline() {
      this.loading = true;
      try {
        let response = await this.$_getShippingTimeline(this.$route.params.id);
        
        this.shipment = response.data.data.shippingActivity;
        this.loading = false;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    myFunction(id) {
      var popup = document.getElementById(id);
      popup.classList.toggle("show");
    },
  },
  mounted(){
    this.nowDate = moment().toString();
    this.getShippingTimeline();
  }
};
</script>

<style lang="scss" scoped>
.timeline-bar {
    width:100%;
    justify-content: space-evenly;
    display: flex;
    align-items: center;
    position: absolute;
    top: 22%;
    left: 50px;
    padding-right: 5px;

    

    .dotted {
        background: #fff;
        /* Others/White */
        height: 1px;
        width: 93%;
        border: 2px dashed #959CB6;
        transform: matrix(1, 0, 0, -1, 0, 0);
    }
}

.points::after{
    content : "";
    position : absolute;
    background-color: rgb(248, 205, 126);
    padding: 3px;
    border-radius: 10px;
    width : 50%;
    margin-top:-35px;
}

.points:last-child:after{
    content : "";
    position : absolute;
    background-color: rgb(248, 205, 126);
    padding: 3px;
    border-radius: 10px;
    width : 0%;
    margin-top:-35px;
}

.points:last-child{
    padding: 20px;
}


.timeline {
    display: flex;
    justify-content: space-between;
    overflow-x: hidden;
    scrollbar-color: orange;
    scrollbar-width: thin;

    .points {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 1px;
        border-radius: 5px;
        background: #F9FAFC;
        text-align: center;

        div {
            padding: 5px;
            margin: 0 auto;
            background-color: white;
            border-radius: 50%;
            border: 5px solid orange;
            z-index: 2;
        }
        .last-child {
            border-radius: 50%;
            padding: 12px;
            border: 5px solid orange;
            z-index: 2;
        }

        p {
            font-size: 12px;
            font-weight: 500;
            color: #000;
        }

        span {
            color: #10233E;
            font-size: 12px;
            font-weight: 100;
            color: #000;
        }
    }
}

.vm-button{
    border : 2px solid #383F51;
    color: #383F51;
    background-color: white;
    padding: 7px;
    width: 150px;

    font-weight: 500;
    border-radius: 10px 10px;
}

.icon-bg {
    width: 50px;
    background: white;
    padding: 1rem;
    display: block;
    border-radius: 50%;
}
</style>